import { render, staticRenderFns } from "./ChangeCity.vue?vue&type=template&id=22b54a30&scoped=true"
import script from "./ChangeCity.vue?vue&type=script&lang=js"
export * from "./ChangeCity.vue?vue&type=script&lang=js"
import style0 from "./ChangeCity.vue?vue&type=style&index=0&id=22b54a30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b54a30",
  null
  
)

export default component.exports